<template>
  <div>
    <base-card>
      <div class="mb_20">
        <base-question text="Grupo de clientes" class="group-title mb_10" />
        <base-select v-model="campaign.alias">
          <option :value="CampaignType.CUSTOM">Toda a base</option>
          <option :value="CampaignType.LAST15DAYS">Não pedem a 15 dias</option>
        </base-select>
      </div>
      <div class="mb_20">
        <base-question text="Defina a data de divulgação" class="group-title mb_10" />
        <base-input v-model="campaign.date" class="mb_0" type="tel" autocomplete="none" :mask="StringLanguage.dateMask" :masked="true" />
      </div>
      <div class="mb_0">
        <base-question text="Turno da divulgação" class="group-title mb_10" />
        <base-select v-model="campaign.run_at">
          <option :value="CampaignRunAt.LUNCH">Almoço</option>
          <option :value="CampaignRunAt.BREAKFAST">Café</option>
          <option :value="CampaignRunAt.DINNER">Jantar</option>
        </base-select>
      </div>
    </base-card>
    <base-card>
      <base-question text="Métodos de disparo" class="group-title mb_20" />
      <base-checkbox v-model="campaign.send.sms.enabled" :checked="campaign.send.sms.enabled" class="mb_15">
        <p class="notification-type">Mensagem SMS</p>
      </base-checkbox>

      <base-checkbox v-model="campaign.send.push.enabled" :checked="campaign.send.push.enabled" class="mb_15">
        <p class="notification-type">Notificação Push</p>
      </base-checkbox>

      <base-checkbox v-model="campaign.send.email.enabled" :checked="campaign.send.email.enabled">
        <p class="notification-type">Mensagem Email</p>
      </base-checkbox>
    </base-card>
    <base-card>
      <base-question text="Simule o disparo" class="group-title mb_10" />
      <p class="simulation-text mb_20">Essa ferramenta te permite testar o envio de divulgações para o contato cadastrado na sua conta!</p>
      <div v-if="timer <= 0">
        <div>
          <div class="d-flex user-info mb_10"><p>Email</p><p>{{user.email}}</p></div>
          <div class="d-flex user-info mb_20"><p>Número de Telefone</p><p>{{Utils.phoneMask(user.phone)}}</p></div>
        </div>
        <base-message v-if="campaign.send.push.enabled" class="mb_20" design="gold">Para realizar a simulação de disparo de Push, você precisa ter o usuário cadastrado em seu aplicativo com o email {{ user.email }}</base-message>
      </div>
      <base-animation v-else :type="'success'" :text="'Agora sim! Disparo de simulação feito com sucesso! Você só precisa aguardar um pouco e irá receber seu teste.'" />

      <p v-if="timer > 0" class="timer">Tentar Novamente ({{ timer }}s)</p>
      <p v-else-if="alreadyTried" class="try-again" @click="sendSimulationCampaign">Tentar novamente</p>
      <base-button v-else class="w-100" text="Disparar simulação" @click="sendSimulationCampaign" design="four"  />
    </base-card>
    <template slot="footer">
      <base-button class="w-100" :text="'Continuar'" @click="addCampaign" />
    </template>
  </div>
</template>
<script>
import { mapState } from "vuex";

import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";
import BaseDrawer from "@/components/Drawer";
import BaseInput from "@/components/Input";
import BaseQuestion from "@/components/Question";
import BaseSelect from "@/components/Select";
import BaseCheckbox from "@/components/Checkbox";
import BaseMessage from "@/components/Message";
import BaseAnimation from "@/components/Animation";

import Utils from "@/utils";
import AccountAPI from "@/api/account";
import MarketingAPI from "@/api/marketing";

import { CampaignType, CampaignRunAt, CampaignStatus } from "easyjs/lib/Schema/Marketing";

export default {
  props: {
    coupon: { type: Object },
  },
  data() {
    return {
      Utils,
      CampaignType,
      CampaignRunAt,
      timer: 0,
      alreadyTried: false,
      user: {
        name: "",
        phone: "",
        email: ""
      },
      campaign: {
        alias: null,
        date: null,
        run_at: null,
        coupon: null,
        send: {
          sms: {
            enabled: false,
            subject: "Novo Cupom",
            template: "Utilize o cupom [coupon_code] na sua proxima compra. Acesse: [tracking_link]"
          },
          push: {
            enabled: false,
            subject: "Novo Cupom",
            template: "Utilize o cupom [coupon_code] na sua próxima compra"
          },
          email: {
            enabled: false,
            subject: "Novo Cupom",
            template: "[user_name] - Utilize o cupom [coupon_code] na sua próxima compra - Acesse: [tracking_link] <img src='[tracking_open_image]'/>"
          }
        },
        status: CampaignStatus.WAITING
      }
    };
  },
  created(){
    this.loadUser();
  },
  methods: {
    loadUser() {
      AccountAPI.me(false).then(response => {
        const { name, phone, email } = response.getData({});

        this.user.name = name;
        this.user.phone = phone;
        this.user.email = email;
      });
    },
    async addCampaign() {
      const campaign = JSON.parse(JSON.stringify(this.campaign));
      campaign.date = Utils.br2Iso(this.campaign.date || "");
      campaign.gift_id = this.coupon.id;
      const { code, value, type, expiration } = this.coupon;
      campaign.coupon = { code, value, type, expiration };

      return MarketingAPI.addCampaign(campaign);
    },
    sendSimulationCampaign() {
      if(!this.isCampaignValid()) return;

      const simulationCampaign = {
        name: this.campaign.name,
        send: this.campaign.send,
        coupon: { code: this.coupon.code, value: this.coupon.value, times: this.coupon.times, type: this.coupon.type },
        user: this.user
      };

      return MarketingAPI.sendSimulation(JSON.parse(JSON.stringify(simulationCampaign))).then(response => {
        if (response.getErrors([]).length > 0) {
          return alert(StringLanguage.saveError);
        }

        this.startTimer();
      });
    },
    isCampaignValid(){
      const { alias, date, send, run_at } = this.campaign;

      if(!alias || !date || !run_at){
        alert("Preencha todas as informações");
        return false;
      }

      let sendTypeSelected = false;
      for(let sendType in send){
        if(send[sendType].enabled){
          sendTypeSelected = true;
          break;
        }
      }

      if(!sendTypeSelected){
        alert("Selecione ao menos um método de disparo");
        return false;
      }

      return true;
    },
    startTimer() {
      this.timer = 25;
      this.alreadyTried = true;
      const timerId = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(timerId);
        }
      }, 1000);
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.store.isMobile
    })
  },
  components: {
    BaseButton,
    BaseCard,
    BaseDrawer,
    BaseInput,
    BaseQuestion,
    BaseSelect,
    BaseCheckbox,
    BaseMessage,
    BaseAnimation,
  }
};
</script>
<style scoped>
.notification-type {
  font-size: 1.3em;
  color: #888888cc;
}
.simulation-text {
  text-align: left;
  font-size: 1.4em;
  color: #bbbbbb;
  font-weight: 300;
}
.user-info{
  height: 37px;
  background: var(--search-bar);
  justify-content: space-between;
  align-items: center;
}
.user-info p{
  font-size: 1.4em;
  margin: 10px 15px;
}
.user-info p:first-child{
  font-weight: bold;
  color: #AAAAAACC;
}
.user-info p:last-child{
  font-size: 1.4em;
  font-weight: 300;
  color: #AAAAAACC;
}
.timer {
  text-align: center;
  font-size: 1.2em;
  color: #999999;
}
.try-again {
  text-align: center;
  font-weight: bold;
  font-size: 1.4em;
  color: var(--default-hover);
}
.try-again:hover {
  cursor: pointer;
}

@media (max-width: 991px) {
  .simulation-text {
    color: var(--default-hover);
  }
  .group-title {
    text-align: left;
    font-size: 1.4em;
    font-weight: bold;
    color: var(--default-hover);
  }
}
</style>
